export class RestoreFilesRequest {
    'destination';
    'files';
    'restoreAccountId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "destination",
            "baseName": "destination",
            "type": "ObjectStorageDestination",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreFilesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
